import { dateStringToNumber } from '@/utils/tools';

import { banDtoToModel ,type  BanDto,type  BanModel } from './bans';
// import { sendRequest } from './network';
// import { fakeGetPlayer, fakeGetPlayers } from './fakenetwork';

export interface PlayerDto {
  created_at: string; // "2024-07-24T14:06:23.445148Z"
  deleted_at: string; // null
  game_code: string; // "game0"
  last_login: string; // "2024-08-11T09:50:30.475768Z"
  metadata?: Record<string, string>; // { key : "value" }
  platform_code: string; // "code0"
  platform_user_id: string; // "random_0"
  player_id: number; // 0
  updated_at: string; // "2024-07-24T14:06:23.445148Z"
  bans?: BanDto[];
}

export function playerDtoToModel(playerDto: PlayerDto): PlayerModel {
  const model: PlayerModel = {
    id: playerDto.player_id.toString(),
    player_id: playerDto.player_id,
    created_at: dateStringToNumber(playerDto.created_at),
    updated_at: dateStringToNumber(playerDto.updated_at),
    deleted_at: dateStringToNumber(playerDto.deleted_at),
    platform_user_id: playerDto.platform_user_id,
    platform_code: playerDto.platform_code,
    game_code: playerDto.game_code,
    last_login: dateStringToNumber(playerDto.last_login),
    bans: playerDto.bans?.map(banDtoToModel) ?? [],
    metadata: playerDto.metadata ?? {},
  };

  return model;
}

export interface PlayerModel {
  id?: string;
  player_id: number;
  created_at: number;
  updated_at: number;
  deleted_at: number;
  platform_user_id: string;
  platform_code: string;
  game_code: string;
  last_login: number;
  metadata?: Record<string, string>;
  bans: BanModel[];
}
